const LocalStorageService = (() => {
  let service
  function getService() {
    if (!service) {
      service = this
      return service
    }
    return service
  }

  function setToken(token) {
    localStorage.setItem('token', token)
    //localStorage.setItem('refresh_token', tokenObj.refresh_token)
  }

  function setAccount(account) {
    localStorage.setItem('account', JSON.stringify(account))
  }

  function getAccessToken() {
    return localStorage.getItem('token')
  }

  function getRefreshToken() {
    return localStorage.getItem('refresh_token')
  }

  function clearToken() {
    localStorage.removeItem('token')
    // localStorage.removeItem('refresh_token')
  }

  function clearAccount() {
    localStorage.removeItem('token')
    // localStorage.removeItem('refresh_token')
  }

  return {
    getService,
    setToken,
    setAccount,
    getAccessToken,
    getRefreshToken,
    clearToken,
    clearAccount
  }
})()

export default LocalStorageService
